// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviewsContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reviewsTitle {
  display: flex;
  width: 100vw;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

.reviewItem {
  margin: 2rem auto;
  display: flex;
  width: 83.33%;
  justify-content: center;
  text-align: left;
}

.reviewContent {
  background-color: #f9f9f9;
  width: 60vw;
  margin-left: 20vw;
  margin-right: 20vw;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 0.5rem;
  padding: 0.25rem;
  margin: 1rem;
  width: 60vw;
  height: auto;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: left;
}

.reviewerName {
  color: #247a97;
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  font-weight: bold;
  text-transform: capitalize;
  display: block;
  justify-content: center;
  padding: 1rem 1rem;
  flex: 0 0 auto;
  width: auto;
  text-align: left;
}

.productLink {
  margin: 0 1.5rem;
  font-size: 2rem;
  text-decoration: underline;
  overflow: hidden;
}

.reviewDescription {
  margin: 0 1.5rem;
  font-size: 1.5rem;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/homePageReviews.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB;sCACoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".reviewsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.reviewsTitle {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n.reviewItem {\n  margin: 2rem auto;\n  display: flex;\n  width: 83.33%;\n  justify-content: center;\n  text-align: left;\n}\n\n.reviewContent {\n  background-color: #f9f9f9;\n  width: 60vw;\n  margin-left: 20vw;\n  margin-right: 20vw;\n  border-radius: 1rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border-radius: 0.5rem;\n  padding: 0.25rem;\n  margin: 1rem;\n  width: 60vw;\n  height: auto;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n}\n\n.reviewerName {\n  color: #247a97;\n  margin-bottom: 0.5rem;\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-transform: capitalize;\n  display: block;\n  justify-content: center;\n  padding: 1rem 1rem;\n  flex: 0 0 auto;\n  width: auto;\n  text-align: left;\n}\n\n.productLink {\n  margin: 0 1.5rem;\n  font-size: 2rem;\n  text-decoration: underline;\n  overflow: hidden;\n}\n\n.reviewDescription {\n  margin: 0 1.5rem;\n  font-size: 1.5rem;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
